import { fmtDate } from "../../extensions/utils";
import { salesStatuses } from "../../extensions/helper";
import ClientAbonStatusChange from "./client-abon-status-change";

const ClientItemAbonStatus = ({ item, expanded, setExpanded, onUpdateClose }) => {
  
  const handleHeaderClick = () => {
    setExpanded(!expanded);
  };

  const stopPropagation = (e) => {
    e.stopPropagation();
  };

  return<div className={!expanded ? "client-subitem-status" : "client-subitem-selected-status"} >
    <div className="client-item-body" onClick={() => handleHeaderClick}>
      <div className="client-item-line-bold-double">
        <div className="client-item-clip">{salesStatuses.find((i) => i.value === item.status)?.label || item.status}</div>
        <div className="client-item-clip-right">{fmtDate(item.docDate)}</div>
      </div>
      <div>
        <div className="client-item-clip" style={{fontSize:"12px"}}>Пользователь: {item.userName}</div>
      </div>
    </div>
    {expanded && (
      <div onClick={stopPropagation}>
        <ClientAbonStatusChange recordId={item.id} onUpdate={() => onUpdateClose()} onClose={() => onUpdateClose()} />
      </div>
    )}
  </div>
}

export default ClientItemAbonStatus;